module.exports = __webpack_public_path__ + "static/media/doc.ef538aee.jpg";